import styled from 'styled-components/macro';
import { FLEX_CONTAINER } from 'utils/styles/flex';
import { SIZE } from 'assets/styles/ScreenSize';
import { Stepper } from '@material-ui/core';
import { COLORS } from 'utils/styles/colors';

export const StyledStepper = styled(Stepper)`
  width: 100%;
  max-width: 858px;
`;

export const StyledStepImage = styled.img`
    display: block;
    border-radius: 24px;
    background: rgba(50, 134, 199, 0.5);

    @media (min-width: ${SIZE.mobile}) {
      width: 12px;
      height: 12px;
    }

    @media (min-width: ${SIZE.iphone}) {
      width: 16px;
      height: 16px;
    }

    @media (min-width: ${SIZE.tablet}) {
      width: 22px;
      height: 22px;
    }

    @media (min-width: ${SIZE.desktop}) {
      width: 32px;
      height: 32px;
    }

    @media (min-width: ${SIZE.bigDesktop}) {
      width: 40px;
      height: 40px;
    }
`;

export const StyledNoSelected = styled.div`
  border-radius: 24px;
  background: ${COLORS.darkGray};

  @media (min-width: ${SIZE.mobile}) {
    width: 12px;
    height: 12px;
  }

  @media (min-width: ${SIZE.iphone}) {
    width: 16px;
    height: 16px;
  }

  @media (min-width: ${SIZE.tablet}) {
    width: 22px;
    height: 22px;
  }

  @media (min-width: ${SIZE.desktop}) {
    width: 32px;
    height: 32px;
  }

  @media (min-width: ${SIZE.bigDesktop}) {
    width: 40px;
    height: 40px;
  }
`;

export const StyledStepperHeader = styled.div`
  ${FLEX_CONTAINER.FlexRow}
  width: 100%;

  @media (min-width: ${SIZE.mobile}) {
    align-items: flex-start;
  }

  @media (min-width: ${SIZE.desktop}) {
    align-items: center;
  }

  .back-action {
    @media (min-width: ${SIZE.mobile}) {
      margin-right: 13px;
    }

    @media (min-width: ${SIZE.iphone}) {
      margin-right: 16px;
    }

    @media (min-width: ${SIZE.tablet}) {
      margin-right: 32px;
      height: 22px;
    }

    @media (min-width: ${SIZE.desktop}) {
      margin-right: 23px;
      height: auto;
    }

    @media (min-width: ${SIZE.bigDesktop}) {
      margin-right: 48px;
    }
  }
`;
